class MATAProductGrid {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      filterDesktopToggle: ".product-grid__open-filter--desktop",
      filterDesktopClose: ".product-grid__close-filter--desktop",
      sortDesktopToggle: ".product-grid__open-sort--desktop",
      sortByRadio: "[name='sort_by']",
      filterFormDesktop: ".filter-form.show-for-large",
      filterFormMobile: ".filter-form.hide-for-large",
      productGrid: ".product-grid",
      desktopFilters: ".product-grid__desktop-filters",
      variantSelector: ".variant-selector",
      inputText: "input[type='text'],input[type='number']",
      inputCheckbox:
        ".offcanvas-filter input[type='radio'], .offcanvas-filter input[type='checkbox']",
      resetFilters: ".product-grid__filters-reset",
      popupTrigger: ".product-grid__popup-trigger",
      popupClose: ".product-grid__popup [data-close]",
      sortOptions: ".product-grid__sort-options",
      mobileFilters: ".product-grid__filters-mobile",
      productCount: "#ProductCount",
    };

    this.init();
  }

  init() {
    this.$filterDesktopToggle = this.$element.find(
      this.selectors.filterDesktopToggle
    );
    this.$filterDesktopClose = this.$element.find(
      this.selectors.filterDesktopClose
    );
    this.$sortDesktopToggle = this.$element.find(
      this.selectors.sortDesktopToggle
    );
    this.$sortByRadio = this.$element.find(this.selectors.sortByRadio);
    this.$filterFormDesktop = this.$element.find(
      this.selectors.filterFormDesktop
    );
    this.$filterFormMobile = this.$element.find(
      this.selectors.filterFormMobile
    );
    this.$desktopFilters = this.$element.find(this.selectors.desktopFilters);
    this.$productGrid = this.$element.find(this.selectors.productGrid);
    this.$inputText = this.$element.find(this.selectors.inputText);
    this.$inputCheckbox = this.$element.find(this.selectors.inputCheckbox);
    this.$resetFilters = this.$element.find(this.selectors.resetFilters);
    this.$popupTrigger = this.$element.find(this.selectors.popupTrigger);
    this.$popupClose = this.$element.find(this.selectors.popupClose);
    this.$sortOptions = this.$element.find(this.selectors.sortOptions);
    this.$mobileFilters = this.$element.find(this.selectors.mobileFilters);

    this.$filterDesktopToggle.on(
      "click",
      this.__handleDesktopFilterToggle.bind(this)
    );
    this.$filterDesktopClose.on(
      "click",
      this.__handleDesktopFilterToggle.bind(this)
    );
    this.$sortDesktopToggle.on(
      "click",
      this.__handleSortToggleClick.bind(this)
    );

    this.$sortByRadio.on(
      "change",
      this.debounce((e) => {
        this.__handleSortRadioChange(e);
      }, 400)
    );
    this.$inputText.on(
      "input",
      this.debounce((e) => {
        this.__handleSortRadioChange(e);
      }, 400)
    );
    this.$inputCheckbox.on(
      "input",
      this.debounce((e) => {
        this.__handleSortRadioChange(e);
      }, 500)
    );

    this.initializeProductCardVideoHover();

    //this.updateGrid();

    this.$resetFilters.on("click", this.__handleFilterReset.bind(this));
    this.$popupTrigger.on("click", this.__handlePopupTriggerClick.bind(this));
    this.$popupClose.on("click", this.__handlePopupCloseClick.bind(this));

    this.updateSortOptionsState();


    const self = this;

    // sync checkboxes between forms
    $(document).on("change", '.filter-form input[type="checkbox"]', function () {
      const name = this.name;
      const value = this.value;
      const checked = this.checked;

      $(`.filter-form input[type="checkbox"][name="${name}"][value="${value}"]`)
        .not(this)
        .prop("checked", checked);

      self.updateGrid(); // run filter
    });

  }

  __handleDesktopFilterToggle(e) {
    this.$filterDesktopToggle;
    this.toggleAriaExpanded(this.$filterDesktopToggle);
  }

  __handleSortToggleClick(e) {
    this.toggleAriaExpanded($(e.currentTarget));
  }

  __handleSortRadioChange(e) {
    this.updateGrid(e.currentTarget);
  }

  __handleFilterReset() {
    this.$element
      .find("input[type='radio'],input[type='checkbox']")
      .prop("checked", false);
    this.$element.find("input[type='text']").val("");

    $('.filter-form').find("input[type='radio'],input[type='checkbox']")
      .prop("checked", false);
    $('.filter-form').find("input[type='text']").val("");

    this.updateGrid();
  }

  __handlePopupTriggerClick(e) {
    const popupID = $(e.currentTarget).data("popup-open");
    const popup = $(popupID);

    this.$productGrid.addClass( "popup-open" );

    popup.fadeIn();
  }

  __handlePopupCloseClick(e) {
    const popup = $( e.currentTarget ).closest( ".product-grid__popup" );
    this.$productGrid.removeClass("popup-open");
    popup.fadeOut();
  }

  updateGrid(e) {
    this.$desktopFilters.addClass("is-loading");
    this.$sortOptions.addClass( "is-loading" );
    this.$mobileFilters.addClass( "is-loading" );
    this.$productGrid.addClass( "is-loading" );

    const results = this.getFilteredProducts().then((res, rej) => {
      this.$productGrid.removeClass( "is-loading" );

      var productsCount = res[0].childElementCount
      var hasFilters = $('.filter-form').find(':input').filter(function() {
        if ($(this).is(':checkbox, :radio')) {
          return this.checked;
        } else {
          return $.trim($(this).val()).length > 0;
        }
      }).length > 0;

      $('#ProductCount').html(productsCount)

      if(productsCount > 0 && hasFilters){
        $('.product-grid__filters-reset').show()
      } else {
        $('.product-grid__filters-reset').hide()
      }
      this.$productGrid.html(res.html());

      this.afterUpdateFunctions();

      this.$desktopFilters.removeClass("is-loading");
      this.$sortOptions.removeClass("is-loading");
      this.$mobileFilters.removeClass("is-loading");

      
    });


    // console.log('e', e);
    this.updateSortOptionsState();
  }

  updateSortOptionsState() {
    console.log('updateSortOptionsState called')
  $('.product-grid__sort-options').each(function () {
    const parent = $(this);
    const checkedInputs = parent.find('input:checked');

    // Toggle 'hasActiveFilter' on the parent
    if (checkedInputs.length > 0) {
      parent.addClass('hasActiveFilter');
    } else {
      parent.removeClass('hasActiveFilter');
    }

    // Toggle 'active' class on individual inputs
    parent.find('input').each(function () {
      $(this).toggleClass('active', $(this).is(':checked'));
    });
  });

  $('.filter-box').each(function () {
    const parent = $(this);
    const checkedInputs = parent.find('input:checked');

    // Toggle 'hasActiveFilter' on the parent
    if (checkedInputs.length > 0) {
      parent.addClass('hasActiveFilter');
    } else {
      parent.removeClass('hasActiveFilter');
    }

    // Toggle 'active' class on individual inputs
    parent.find('input').each(function () {
      $(this).toggleClass('active', $(this).is(':checked'));
    });
  });

}

  getFilteredProducts(pageURL) {
    console.log('getFilteredProducts', pageURL)
    /* const form =
      $(window).width() <= 1023
        ? this.$filterFormMobile
        : this.$filterFormDesktop; */
    // we're now using just the desktop form
    const form = this.$filterFormDesktop;
    const actionUrl = form.attr("action");
    // const values = form.serialize();
    // let values = new URLSearchParams(form.serialize()).toString();
    let values = form.serialize();
    
    // ✅ Deduplicate only identical key=value pairs
    const parts = values.split("&");
    const seen = new Set();
    const deduped = parts.filter(param => {
      if (seen.has(param)) return false;
      seen.add(param);
      return true;
    });

      values = deduped.join("&");



    return new Promise((res, rej) => {
      $.ajax({
        type: "GET",
        url: pageURL ?? actionUrl,
        data: values,
        success: (data) => {
          const grid = $(data).find(this.selectors.productGrid);

          if (!pageURL) {
            history.pushState({ formData: values }, "", "?" + values);
          }

          res(grid);
        },
      });

    });
  }

  toggleAriaExpanded(e) {
    e.attr("aria-expanded", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
  }

  afterUpdateFunctions() {
    this.$element.find(this.selectors.variantSelector).each((i, e) => {
      const variantSelector = new VariantSelector(i, e);
    });

    this.$productGrid.find(".product-card--grouped").each((i,e) => {
      const productCard = $(e);
      const color = productCard.find(".product-card__colors li span");
      const changeURL = () => {
        // setTimeout(() => {
          const anchor = productCard.find(".product-card__media");
          const selectedColor = productCard.find(
            ".product-card__colors span.is-active"
          );

          anchor.attr("href", selectedColor.data("url"));
          productCard.find(".price").html(selectedColor.data("price"));
        // }, 1);
      };
      changeURL();

      const productID = productCard.find( ".product-card__colors li span.is-active" ).data( "product-id" );
      productCard.find( ".product-card__form" ).removeClass( "is-active" );
      productCard.find( `.product-card__form[data-product-id='${productID}']` ).addClass( "is-active" );

      color.on("click", (e) => {
        const productID = $(e.currentTarget).data("product-id");
        color.removeClass("is-active");
        $(e.currentTarget).addClass("is-active");
        productCard.find(".product-card__form").removeClass("is-active");
        productCard
          .find(`.product-card__form[data-product-id='${productID}']`)
          .addClass("is-active");

        productCard
          .find(".product-card__media-carousel.flickity-enabled")
          .flickity("selectCell", $(e.currentTarget).data("index"));
        changeURL();
      });
      productCard.find(".product-card__media-carousel").flickity({
        selectedAttraction: 0.1,
        friction: 0.55,
        wrapAround: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        pageDots: true,
      });

      productCard
        .find(".product-card__media-carousel.flickity-enabled")
        .on("change.flickity", function (event, index) {
          productCard
            .find(".product-card__image video")
            .each((i, e) => $(e).get(0).pause());
          if (productCard.find(".product-card__image.is-selected video").length)
            productCard
              .find(".product-card__image.is-selected video")
              .get(0)
              .play();
        });
    });

    this.$productGrid
      .find(".product-card:not(.product-card--grouped)")
      .each((i,e) => {
        const productCard = $(e);
        const color = productCard.find(".product-card__colors li span");
        color.on("click", (e) => {
          color.removeClass("is-active");
          $(e.currentTarget).addClass("is-active");

          productCard
            .find(".product-card__media-carousel.flickity-enabled")
            .flickity("selectCell", $(e.currentTarget).data("index"));
        });
        productCard.find(".product-card__media-carousel").flickity({
          selectedAttraction: 0.1,
          friction: 0.55,
          wrapAround: true,
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          pageDots: true,
        });
      });

    this.initializeProductCardVideoHover();
  }

  initializeProductCardVideoHover() {

    this.$productGrid.find(".product-card--grouped").each((i,e) => {
      const productCard = $(e);
      productCard
        .on("mouseover", (e) => {
          const video = $(e.currentTarget).find(
            ".product-card__image.is-selected video"
          );
          if (!video.length) return;

          if (video.get(0).paused) {
            video.get(0).play();
          }
        })
        .on("mouseout", (e) => {
          const video = $(e.currentTarget).find(
            ".product-card__image.is-selected video"
          );
          if (!video.length) return;

          if (!video.get(0).paused) {
            video.get(0).pause();
          }
        });
    });

    this.$productGrid.find(".product-card").each((i, e) => {
      const productCard = $(e);
      productCard
        .on("mouseover", (e) => {
          const video = $(e.currentTarget).find(
            ".product-card__secondary-image video"
          );
          if (!video.length) return;

          if (video.get(0).paused) {
            video.get(0).play();
          }
        })
        .on("mouseout", (e) => {
          const video = $(e.currentTarget).find(
            ".product-card__secondary-image video"
          );
          if (!video.length) return;

          if (!video.get(0).paused) {
            video.get(0).pause();
          }
        });
    });
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
}